module.exports = __webpack_public_path__ + "static/media/icon-phone.f3b44489.svg";